import type { PopWhatsIncludedItemData } from '@/app/[locale]/product/_types/whatsIncluded';

import PopWhatsIncludedItem from './PopWhatsIncludedItem';

export interface PopWhatsIncludedProps {
  readonly items: PopWhatsIncludedItemData[];
}

const PopWhatsIncluded = ({ items }: PopWhatsIncludedProps) => {
  return (
    <section>
      {items.map((item, i) => (
        <PopWhatsIncludedItem {...item} index={i} key={item.title} />
      ))}
    </section>
  );
};

export default PopWhatsIncluded;
